import type {ReactElement} from 'react';
import React, {useState, useEffect} from 'react';
import type {TextProps} from '@Components/text';
import {Text} from '@Components/text';

interface LoadingTextProps {
  textProps: TextProps;
  isAnimating?: boolean;
  interval?: number;
  className?: string;
}

const DEFAULT_INTERVAL = 600;
const MAX_NUMBER_OF_DOTS = 3;

export function LoadingText({isAnimating = false, interval = DEFAULT_INTERVAL, ...props}: LoadingTextProps): ReactElement<any> {
  const [dots, setDots] = useState('');

  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    if (isAnimating) {
      intervalId = setInterval(() => {
        setDots((prevDots) => {
          return prevDots.length < MAX_NUMBER_OF_DOTS ? `${prevDots}.` : '';
        });
      }, interval);
    } else {
      setDots('');
    }

    return () => {
      return clearInterval(intervalId);
    };
  }, [isAnimating]);

  return (
    <div className={`flexbox _full-width ${props.className ?? ''}`}>
      <Text {...props.textProps} />
      {isAnimating ? <Text {...props.textProps} val={dots} /> : null}
    </div>
  );
}
